export default __webpack_public_path__ + "static/media/1843.6ade3130.png";